import { render, staticRenderFns } from "./EditVideoLibrary.vue?vue&type=template&id=e944d038&"
import script from "./EditVideoLibrary.vue?vue&type=script&lang=js&"
export * from "./EditVideoLibrary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports